export default __webpack_public_path__ + "static/mail-hover-7f65f403cd56616c90769b0e9394437a.png";